import { RegistrationApiFormatterInput, RegistrationApiFormatterOutput } from '@/components/api/registrationApi/types'
import { SITUATION } from '@/components/constants'
import { getDeviceFingerprint } from '@/components/utils/deviceFingerprint'
import { isLpRegistrationFlagSet } from '@/components/utils/lpRegistrationFlag'

const normalizeSituation = (status: string | number | undefined | null): number => {
    if (typeof status === 'number') return status
    if (!status) return SITUATION.UNEMPLOYED

    const s = String(status).trim().toLowerCase()

    const employedKeywords = ['就業中', '在職中', 'tenure']
    if (employedKeywords.some(keyword => s === keyword.toLowerCase())) {
        return SITUATION.EMPLOYED
    }

    return SITUATION.UNEMPLOYED
}

export const registrationApiFormatter = (
    data: RegistrationApiFormatterInput
): RegistrationApiFormatterOutput => {
    const fullName = `${data.lastName ?? ''}${data.firstName ?? ''}`
    const hasOnlyAllowedChars = !fullName.match(/[^a-zA-Zａ-ｚＡ-Ｚ0-9０-９ァ-ヶｱ-ﾝﾞﾟ・=＝ー－―\- 　]/)
    const foreignNationality = hasOnlyAllowedChars ? 'TRUE' : 'FALSE'
    
    return {
        first_name: data.firstName,
        last_name: data.lastName,
        age: typeof data.age === 'number' ? data.age : (data.age ? parseInt(String(data.age), 10) : undefined),
        mobile: data.phone,
        line_id: data.lineId,
        line_contact_preferred: data.preferLineContact ?? false,
        situation: typeof data.workingStatus === 'number' ? data.workingStatus : normalizeSituation(data.workingStatus),
        experience: data.experienceYears ?? data.experience,
        email: data.email,
        registration_area_name: data.prefecture,
        foreign_nationality: foreignNationality,
        source_url: window.location.href,
        local_flag: isLpRegistrationFlagSet(),
        ...getDeviceFingerprint(),
        job_change_interest: data.jobChangeInterest || undefined,
    }
}
